var photographersAndNumberOfPhotos = {
    angela_thompson: 10,
    christopher_goldsack: 10,
    maggie_berry: 10,
    nathan_comben: 10,
    peter_chamberlain: 10,
    ann_beauchamp: 10,
    richard_escott: 10,
    vicki_portanier: 10,
    sonia_bonkat: 10,
    bevil_templeton_smith: 10
};

var photographerImages = {};

Object.keys(photographersAndNumberOfPhotos).forEach(photographer => {
    var photos = [];
    var numberPhotos = photographersAndNumberOfPhotos[photographer];

    for (let i = 1; i <= numberPhotos; i++) {
        photos.push("../images/photographers/" + photographer + "/" + i + ".jpg");
    }

    photographerImages[photographer] = {
        photos: photos
    }
});

export default photographerImages;


// WEBPACK FOOTER //
// ./src/data/galleries.js